import script from "./ContactComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactComponent.vue?vue&type=script&setup=true&lang=js"

import "./ContactComponent.vue?vue&type=style&index=0&id=fffa7fca&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fffa7fca"]])

export default __exports__